import createIcon from '../../createIcon';

/**
 * @component @name Description
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2QzQuOSAyIDQuMDEgMi45IDQuMDEgNEw0IDIwQzQgMjEuMSA0Ljg5IDIyIDUuOTkgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhMMTQgMlpNMTYgMThIOFYxNkgxNlYxOFpNMTYgMTRIOFYxMkgxNlYxNFpNMTMgOVYzLjVMMTguNSA5SDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Description = createIcon('Description', [
  [
    'path',
    {
      d: 'M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM16 18H8V16H16V18ZM16 14H8V12H16V14ZM13 9V3.5L18.5 9H13Z',
      key: 'obyfh',
    },
  ],
]);

export default Description;
